import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
	// This component is used to store deeplink when user is not logged in.
	constructor(private oauthService: OAuthService, private route: ActivatedRoute, private router: Router) {
		const url = window.location.href;
		const linkId = this.route.snapshot.paramMap.get('linkId') || '';

		if (url.indexOf("/document/") >= 0) {
			localStorage.setItem('details', linkId);
		} else if (url.indexOf("/list/") >= 0) {
			localStorage.setItem('list', linkId);
		}
		if (this.oauthService.hasValidAccessToken()) {
			this.router.navigate(['/dashboard']);
		}
	}
}
